import { render, staticRenderFns } from "./stocktypes.vue?vue&type=template&id=4f4db61d&scoped=true"
import script from "./stocktypes.vue?vue&type=script&lang=js"
export * from "./stocktypes.vue?vue&type=script&lang=js"
import style0 from "./stocktypes.vue?vue&type=style&index=0&id=4f4db61d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4db61d",
  null
  
)

export default component.exports